// src/components/BoardPack/pages/kpi_chart_12.jsx
import React, { useState, useEffect, useRef } from "react";
import { apiCall } from "@/api/apiCall";
import LoadingComponent from "@/components/common/LoadingComponent";
import ErrorState from "@/components/common/ErrorStateComponent";
import ReusableKPIChart from "../components/charts/ReusableKPIChart";
import { useQueue } from "@/context/QueueContext";
import { processParams } from "../utils/paramsHelper";
import { useNavigate } from "react-router-dom";

const KpiChart12 = ({ year = "", month = "", monthNumber = "", contract = "", page = null, isRefresh = false }) => {
  const { enqueue } = useQueue();
  const navigate = useNavigate();

  const [chartData, setChartData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const hasFetchedRef = useRef(false);

  const transformApiData = (apiData) => {
    const contractName = Object.keys(apiData.data);
    if (!apiData?.data || !apiData.data[contractName]) {
      return [];
    }
    const contractData = apiData.data[contractName];
    const months = [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
    ];

    // ✅ Fixed: null/undefined/empty → 0, NaN → 0
    const safeFloat = (value) => {
      if (value === null || value === undefined || value === "" || value === "-") return 0;
      const parsed = parseFloat(typeof value === "string" ? value.replace(/,/g, "") : value);
      return isNaN(parsed) ? 0 : parsed;
    };

    const transformedData = [];

    const year = Object.keys(contractData.Parking_Revenue_in_RC);

    // ✅ Fixed: "month in yearData" — 0 value wale months bhi push honge
    // Process year[0] data
    months.forEach((month) => {
      const yearData = contractData.Parking_Revenue_in_RC?.[year[0]];
      if (yearData && month in yearData) {
        transformedData.push({
          month: `${month}-${year[0]}`,
          year: year[0],
          revenue: safeFloat(contractData.Parking_Revenue_in_RC?.[year[0]]?.[month]),
          transaction: safeFloat(contractData.Ticket_Count?.[year[0]]?.[month]),
          atv: safeFloat(contractData.ATV?.[year[0]]?.[month]),
          als: safeFloat(contractData.ALS?.[year[0]]?.[month]),
        });
      }
    });

    // Process year[1] data
    months.forEach((month) => {
      const yearData = contractData.Parking_Revenue_in_RC?.[year[1]];
      if (yearData && month in yearData) {
        transformedData.push({
          month: `${month}-${year[1]}`,
          year: year[1],
          revenue: safeFloat(contractData.Parking_Revenue_in_RC?.[year[1]]?.[month]),
          transaction: safeFloat(contractData.Ticket_Count?.[year[1]]?.[month]),
          atv: safeFloat(contractData.ATV?.[year[1]]?.[month]),
          als: safeFloat(contractData.ALS?.[year[1]]?.[month]),
        });
      }
    });

    return transformedData;
  };

  useEffect(() => {
    if (!year || !month || !contract) return;
    if (hasFetchedRef.current) return;

    hasFetchedRef.current = true;
    fetchData();
  }, [year, month, contract]);

  const fetchData = async () => {
    try {
      setLoading(true);
      setError(null);

      
const apiParams = processParams(page?.params || {}, { year, month, contract });

      const response = await enqueue(() => apiCall("GET", "/board-pack/page-twelve", apiParams,navigate,false,false,isRefresh));

      if (response?.success) {
        const transformed = transformApiData(response);
        setChartData(transformed);
      } else {
        setError(response?.message || "Failed to load data. Please try again later.");
      }
    } catch (err) {
      setError(err?.message || "Failed to load data. Please try again later.");
      console.error("Error fetching data:", err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <LoadingComponent />;
  if (error) return <ErrorState error={error} onRetry={fetchData} />;

  return (
    <ReusableKPIChart
      chartData={chartData}
      title={page?.title}
      subtitle={page?.subtitle}
      chartTitle={page?.in_chart_content_line_1}
      colors={page?.colors}
      labels={page?.labels}
      showDataLabels={page?.showDataLabels ? true : false}
      showRamadanRow={true}
      yAxisLabel={page?.yAxisLabel || "Off Street Parking"}
      ramadanBorderColor="#00d4ff"
      yAxisFormatters={{
        left: (value) => (value / 1000000).toFixed(1) + "M",
        right: (value) => value,
      }}
    />
  );
};

export default KpiChart12;